import {
    Component,
    Input,
    QueryList,
    ViewChildren,
    Output,
    EventEmitter,
} from '@angular/core';

import { FormGroup } from '@angular/forms';
import { AutoCompleteComponent } from './motif-inputs/auto-complete/auto-complete.component';
import { DatePasseExacteComponent } from './motif-inputs/date-passe-exacte/date-passe-exacte.component';
import { DateComponent } from './motif-inputs/date/date.component';
import { DureeComponent } from './motif-inputs/duree/duree.component';
import { TauxComponent } from './motif-inputs/taux/taux.component';
@Component({
    selector: 'app-motif-component',
    templateUrl: './motif.component.html',
    styleUrls: ['./motif.component.scss'],
})
export class MotifComponent {
    @Output() removeMotifEvent = new EventEmitter<string>();
    @ViewChildren(AutoCompleteComponent)
    autoCompleteComponents!: QueryList<AutoCompleteComponent>;
    @ViewChildren(TauxComponent) tauxComponents!: QueryList<TauxComponent>;
    @ViewChildren(DureeComponent) dureeComponents!: QueryList<TauxComponent>;
    @ViewChildren(DatePasseExacteComponent)
    datePasseExacteComponents!: QueryList<DatePasseExacteComponent>;
    @ViewChildren(DateComponent) dateComponents!: QueryList<DateComponent>;

    @Input() qsForm: FormGroup = new FormGroup({});
    @Input() questionQuestionnaireSante: any;
    @Input() controlId: string;
    @Input() controlsEnable: boolean;
    @Input() charCounter = 0;
    // Todo get from conf
    @Input() maxCharCounter = 500;
    @Output() valuesChanged: EventEmitter<any> = new EventEmitter();
    removeMotif() {
        this.questionQuestionnaireSante.listeSousQuestions.forEach(
            (sousQuestion) => {
                this.qsForm.removeControl(
                    `${sousQuestion.id}-${this.controlId}`
                );
            }
        );
        this.removeMotifEvent.emit();
    }

    getMotif(): any {
        const listeElements: any[] = [];
        this.autoCompleteComponents.forEach((autoComplete) => {
            listeElements.push(autoComplete.getSousReponse());
        });
        this.tauxComponents.forEach((taux) => {
            listeElements.push(taux.getSousReponse());
        });
        this.datePasseExacteComponents.forEach((date) => {
            listeElements.push(date.getSousReponse());
        });
        this.dateComponents.forEach((date) => {
            listeElements.push(date.getSousReponse());
        });
        this.dureeComponents.forEach((duree) => {
            listeElements.push(duree.getSousReponse());
        });
        return { listeElements };
    }

    gridSize(subQuestion: any) {
        switch (subQuestion.type) {
            case 'medicament':
                return 'wide';
            case 'analyse':
            case 'chaine':
            case 'maladie':
                return 'medium';
            default:
                return 'small';
        }
    }

    emitValuesChanged() {
        this.valuesChanged.emit();
    }
    getCharCounter(): number {
        let counter = 0;
        this.autoCompleteComponents.forEach((autoComplete) => {
            counter += autoComplete.getCounterValue();
        });
        return counter;
    }
}
